import React,{ useState } from 'react'
import ModelSelector, { AI_PROVIDERS } from './ModelSelector'; 
import StyleSelector, { TONE_OPTIONS, LANGUAGE_OPTIONS } from './StyleSelector';
import SpeechConfig from '../../../../components/SpeechConfig';
import { 
    Dialog, 
    DialogContent, 
    IconButton, 
    Tooltip
} from '@mui/material';
import { Settings } from '@mui/icons-material';



function AssistSetting({selectedModel,setSelectedModel,selectAIProvider,setSelectAIProvider, selectedTone,setSelectedTone,selectedLanguage,setSelectedLanguage}) {
  
    const [dialogStatus, setDialogStatus] = useState(false);
  
    return (
    
        <>
            <Tooltip title="Update Setting">
                <IconButton onClick={(e)=>setDialogStatus(true)} >
                    <Settings/>
                </IconButton>
            </Tooltip>

            <Dialog 
                open={dialogStatus}
                keepMounted
                onClose={(e)=>setDialogStatus(false)} 
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12 my-2'>
                            <SpeechConfig />
                        </div>
                        <div className='col-md-12 my-3'>
                            <ModelSelector 
                                selectedModel={selectedModel} 
                                onModelChange={setSelectedModel}
                                selectAIProvider={selectAIProvider}
                                onAiProviderChange={setSelectAIProvider}
                            />
                        </div>
                        <div className='col-md-12 my-3'>
                            <StyleSelector 
                                selectedTone={selectedTone}
                                onToneChange={setSelectedTone}
                                selectedLanguage={selectedLanguage}
                                onLanguageChange={setSelectedLanguage}
                            />
                        </div>
                    </div>
                    {/* Model Selector Component */}  
                </DialogContent>
            </Dialog>
        </>

    )
}

export default AssistSetting